import { render, staticRenderFns } from "./ClockServerGallery.vue?vue&type=template&id=9844c5de&"
import script from "./ClockServerGallery.vue?vue&type=script&lang=js&"
export * from "./ClockServerGallery.vue?vue&type=script&lang=js&"
import style0 from "./ClockServerGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports